import { appendLocaleSources } from '../../hooks/useTranslate'

const i18nScope = 'gasAndOil'

appendLocaleSources({
  [i18nScope]: {
    hourlyProduction: 'Часовая добыча',
    dailyProduction: 'Дневная добыча',
    monthlyProduction: 'Месячная добыча',
    annualProduction: 'Годовая добыча',
  }
}, 'ru')

// appendLocaleSources({
//   [i18nScope]: {
//     dailyProduction: '',
//     monthlyProduction: '',
//     annualProduction: '',
//   }
// }, 'uz')

appendLocaleSources({
  [i18nScope]: {
    dailyProduction: 'Kunlik ishlab chiqarish',
    monthlyProduction: 'Oylik ishlab chiqarish',
    annualProduction: 'Yillik ishlab chiqarish',
  }
}, 'uz-Latn')

appendLocaleSources({
  [i18nScope]: {
    dailyProduction: 'Daily production',
    monthlyProduction: 'Monthly production',
    annualProduction: 'Annual production',
  }
}, 'en')

export {
  i18nScope
}
